import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import { TXTWCL_You_can_find_out_more_about_ch_ELL } from './HelpSectionContent.messages.json';

const HelpSectionContent: React.FC = () => (
  <Translation
    values={{
      a: (msg: React.ReactNode) => (
        <ResolverLink resolverTag={ResolverTag.HelpUpdateDetails}>{msg}</ResolverLink>
      )
    }}
    {...TXTWCL_You_can_find_out_more_about_ch_ELL}
  />
);

export default HelpSectionContent;
